import { useQuery } from "@tanstack/react-query";
import { Wrench, FolderKanban, Tags, Code2, MessageSquareQuote, BadgePercent, Inbox } from "lucide-react";
import { api } from "../../lib/api";

const CARDS = [
  { key: "services", label: "Servicios", icon: Wrench },
  { key: "brands", label: "Marcas", icon: Tags },
  { key: "software", label: "Software GLG", icon: Code2 },
  { key: "testimonials", label: "Testimonios", icon: MessageSquareQuote },
  { key: "promotions", label: "Promociones", icon: BadgePercent },
];

export default function Dashboard() {
  const { data } = useQuery({
    queryKey: ["admin-stats"],
    queryFn: async () => (await api.get("/admin/stats")).data,
  });
  const s = data || {};

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold sm:text-3xl">Dashboard</h1>
      <p className="mt-1 text-sm text-white/50">Resumen del contenido de tu sitio web</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} data-testid={`stat-${c.key}`} className="rounded-2xl border border-white/10 bg-glg-surface/60 p-6">
              <div className="flex items-center justify-between">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-glg-blue/15">
                  <Icon className="h-5 w-5 text-glg-blue" />
                </div>
                <span className="text-xs text-white/40">{s[`${c.key}_published`] ?? 0} publicados</span>
              </div>
              <div className="mt-4 font-heading text-3xl font-bold">{s[c.key] ?? 0}</div>
              <div className="text-sm text-white/50">{c.label}</div>
            </div>
          );
        })}

        <div data-testid="stat-leads" className="rounded-2xl border border-glg-green/30 bg-glg-green/5 p-6">
          <div className="flex items-center justify-between">
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-glg-green/15">
              <Inbox className="h-5 w-5 text-glg-green" />
            </div>
            <span className="text-xs text-glg-green">{s.leads_new ?? 0} nuevos</span>
          </div>
          <div className="mt-4 font-heading text-3xl font-bold">{s.leads ?? 0}</div>
          <div className="text-sm text-white/50">Leads recibidos</div>
        </div>
      </div>
    </div>
  );
}
